import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormLabel,
} from '@material-ui/core';
import React, {useState, useEffect} from 'react';
import {arraysEqual} from './../../../../helpers/functions';

const Multibox = ({data, setCorrect}) => {
  const [answersClicked, setAnswersClicked] = useState([]);

  //Contiene las respuestas del usuario
  const [checked, setChecked] = useState(
    new Array(data.answers.length).fill(false),
  );

  useEffect(() => {
    setAnswersClicked([]);
    setChecked(new Array(data.answers.length).fill(false));
  }, [data]);

  function containsObject(answerClicked, listAnswerUser) {
    listAnswerUser.forEach((answerUser) => {
      if (answerClicked === answerUser) return true;
    });
    return false;
  }

  const evaluateMultiple = (answer, ix) => {
    /// Cambia el estado del array que contiene las elecciones de posibles respuestas
    const newCheckedArray = getNewCheckedArray(ix);
    setChecked(newCheckedArray);
    /// ----- ///

    let helper = [...answersClicked];
    const correctAnswers = data.answers.filter((x) => x.correctAnswer === true);

    if (containsObject(answer, helper)) {
      let index = helper.findIndex((x) => x === answer);
      helper.splice(index, 1);
    } else {
      helper.push(answer);
    }

    setAnswersClicked(helper);
    setCorrect(arraysEqual(helper, correctAnswers));
  };

  function getNewCheckedArray(ix) {
    let newCheckedArray = [...checked];
    newCheckedArray[ix] = !checked[ix];
    return [...newCheckedArray];
  }

  return (
    <FormGroup style={{paddingLeft: '10%'}}>
      {data.answers.map((answer, i) => {
        return (
          <FormControlLabel
            style={{paddingBottom: '30px', textAlign: 'initial'}}
            key={i}
            control={
              <Checkbox
                // value={data.iD_Answer}
                checked={checked[i] || false}
                onChange={() => {
                  evaluateMultiple(answer, i);
                }}
              />
            }
            label={
              <FormLabel component="legend">{answer.text_Answer}</FormLabel>
            }
          />
        );
      })}
    </FormGroup>
  );
};

export default Multibox;
